import { Config } from '@cvx/cal';

const calConfig: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: 'localStorage',
  instance: 'https://login.microsoftonline.com/',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  clientId: '91d755c7-0d36-45a8-a217-2f9375aa9667',
  redirectUri: 'https://caira-test.azure.chevron.com',
  oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  graphScopes: ['User.Read', 'User.Read.All'],
};

export const environment = {
  calConfig: calConfig,
  production: false,
  envName: 'test',
  requestTimeout: 30000,
  apiEndpoint: 'https://caira-api-test-cvx.azurewebsites.net',
  redirectUri: 'https://caira-test.azure.chevron.com',
};